export enum PermissionLevel {
    VIEW_ONLY = 1000,
    SUPPORT = 2000,
    MANAGER = 3000,
    ADMIN = 4000,
}

export const PERMISSION_LEVEL_LABEL_KEYS: Record<PermissionLevel, string> = {
    [PermissionLevel.VIEW_ONLY]: "permissionLevel_viewOnly",
    [PermissionLevel.SUPPORT]: "permissionLevel_support",
    [PermissionLevel.MANAGER]: "permissionLevel_manager",
    [PermissionLevel.ADMIN]: "permissionLevel_admin",
};

export enum UserStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum UserField {
    ID = "id",
    FIRST_NAME = "firstName",
    LAST_NAME = "lastName",
    EMAIL = "email",
    PERMISSION_LEVEL = "permissionLevel",
    STATUS = "status",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
}

export interface User {
    [UserField.ID]: number;
    [UserField.FIRST_NAME]: string;
    [UserField.LAST_NAME]: string;
    [UserField.EMAIL]: string;
    [UserField.PERMISSION_LEVEL]: PermissionLevel;
    [UserField.STATUS]: UserStatus;
    [UserField.CREATED_AT]: string;
    [UserField.UPDATED_AT]: string;
}
